/*
 * Copyright (c) Nexign, JSC, 2019-2023.
 */
/**
 *
 * @author Vladislav Oshkanov
 * @author Aleksandr Perkhunov
 * @author Andrey Dubov
 * @version 1.23.0
 * @since 1.0.0
 */
import styled from 'styled-components';

import { loader } from '../../../../theme';
import { ICommonTranslation } from '../../../internationalization/types';

export const LoaderContainerStyled = styled.div.attrs({
    className: 'loader',
})`
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    @keyframes loader {
        0% {
            display: none;
            opacity: 0;
        }
        1% {
            display: block;
            opacity: 0;
        }
        100% {
            display: block;
            opacity: 1;
        }
    }
`;

type TBackdrop = {
    opacity?: number;
};

export const LoaderFrameBackdropStyled = styled.div.attrs({
    className: 'loader-backdrop',
})<TBackdrop>`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${(props) => `rgba(255, 255, 255,${props.opacity || 0.9})`};
    z-index: 100;
`;

export const LoaderTextStyled = styled.div<{ translation?: ICommonTranslation }>`
    width: 100%;
    margin-top: 21px;
    text-align: center;
`;

export const LoaderImageStyled = styled.div.attrs({
    className: 'loader__image',
})`
    ${loader.customizeStyle}
    i {
        display: ${loader.customizeStyle ? 'none' : 'block'};
        position: relative;
        left: 50%;
        top: 50%;
        width: 150px;
        height: 150px;
        margin: -75px 0 0 -75px;
        border-radius: 50%;
        border: 3px solid transparent;
        border-top-color: #067148;
        animation: spin 5s linear infinite;

        &:before {
            content: '';
            position: absolute;
            top: 5px;
            left: 5px;
            right: 5px;
            bottom: 5px;
            border-radius: 50%;
            border: 3px solid transparent;
            border-top-color: #1a983d;
            animation: spin 7s linear infinite;
        }

        &:after {
            content: '';
            position: absolute;
            top: 15px;
            left: 15px;
            right: 15px;
            bottom: 15px;
            border-radius: 50%;
            border: 3px solid transparent;
            border-top-color: #14885b;
            animation: spin 2.5s linear infinite;
        }

        @keyframes spin {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
        }
    }
`;

export const LoaderFrameStyled = styled.div.attrs({
    className: 'loader__frame',
})`
    animation: loader 150ms ease-out;
    position: absolute;
    z-index: 500;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    padding: 40px;
    min-width: 50%;
    max-width: 750px;
`;
